export default __webpack_public_path__ + "static/media/taxon_counter.45627875.gif";